import { createPath } from 'react-router-dom';
import { appRoutes, isInTwoFactorAuthenticationLoginFlow } from '#services';
// This could be developed to contain
// not only strings but also regexes
// so that we can mach specific routes.
const ROUTES_TO_DISCARD = [appRoutes.account()];
export const privateRoutePredicate = ({ currentUser, location, }) => {
    if (!currentUser || isInTwoFactorAuthenticationLoginFlow(currentUser)) {
        const navigatedFrom = ROUTES_TO_DISCARD.includes(location?.pathname ?? '')
            ? undefined
            : location
                ? createPath(location)
                : undefined;
        return {
            isSuccess: false,
            navigateTo: appRoutes.login(),
            navigatedFrom,
        };
    }
    if (!currentUser?.emailVerified) {
        return { isSuccess: false, navigateTo: appRoutes.verifyEmail() };
    }
    return { isSuccess: true };
};
